import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import UnclearSignatureCard from '../Card/UnclearSignatureCard';
import { getUnclearSignaturePDFApi } from 'api/pdf';
import { getUnclearSignatureWORDApi } from 'api/word';

function UnclearSignatureDialog({ open, onClose, meetingId, docType }) {

  const handleSubmit = (data) => {
    if (docType === "pdf") {
      getUnclearSignaturePDFApi(meetingId, data.fullName, data.position)
        .then(() => {
          onClose();
        })
        .catch((error) => {
          console.error("API Çağrısında Hata:", error);
        });
    } else if (docType === "word") {
      getUnclearSignatureWORDApi(meetingId, data.fullName, data.position)
        .then(() => {
          onClose();
        })
        .catch((error) => {
          console.error("API Çağrısında Hata:", error);
        });
    }

  };


  return (
    <Dialog onClose={onClose} open={open} maxWidth={'sm'} fullWidth>
      <DialogTitle>İmzalanacak Kararlar</DialogTitle>
      <DialogContent>
        <UnclearSignatureCard onSubmit={handleSubmit} meetingId={meetingId} docType={docType} />
      </DialogContent>

    </Dialog>
  );
}


export default UnclearSignatureDialog